// components/Testimonials.js
import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Ramesh subramani",
      company: "A2Cakes",
      text: "KadaiPOS transformed our business. We've seen a 30% increase in sales since implementation thanks to the powerful analytics and customer management features.",
      rating: 5
    },
    {
      name: "Sathish kumar ",
      company: "Restaurant Owner",
      text: "The inventory management alone is worth the price. We've reduced our stockouts by 85% and improved our inventory turnover ratio significantly.",
      rating: 5
    },
    {
      name: "Gokul",
      company: "GBcakes",
      text: "Customer support is incredible. They helped us set up everything perfectly and were available 24/7 during our transition period. Couldn't be happier!",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="section">
      <div className="container">
        <h2 className="section-title">What Our Customers Say</h2>
        <p className="section-subtitle">Join thousands of satisfied business owners who have transformed their operations with KadaiPOS</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">
                {'★'.repeat(testimonial.rating)}
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-author">
                <strong>{testimonial.name}</strong>
                <span>{testimonial.company}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;